<template>
  <el-input
    ref="input"
    :type="type"
    :clearable="clearable"
    :class="inputClass"
    :disabled="disabled"
    @change="setValue"
    @blur="blur"
    v-model="inputModel"
    :placeholder="placeholder"
    :prefix-icon="prefixIcon"
    :suffix-icon="suffixIcon">
  </el-input>
</template>

<script>
  export default {
    name: 'qunji-input',
    props: {
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String
      },
      defaultValue: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      inputClass: {
        type: String
      },
      prefixIcon: {
        type: String
      },
      suffixIcon: {
        type: String
      },
      value: {
        type: [String,Number]
      }
    },
    data() {
      return {
        inputModel: this.defaultValue
      }
    },
    created() {
    },
    mounted() {
      if (this.isNotEmpty(this.inputModel)) {
        this.setValue(this.inputModel)
      }
    },
    watch: {
      value(val, oldValue) {
        if (val === this.inputModel) return;
        this.inputModel = val;
      },
    },
    methods: {
      setValue(val) {
        this.$emit('input', val)
      },
      blur() {
        this.$emit('blur')
      }
    }
  }
</script>
